import { questionApi } from '@/lib/api/questionnaireApi';
import { QuestionFormData } from '@/lib/questionSchema';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { handleQueryError } from '@/lib/queryErrorHandler';

export function useCreateQuestion({
  sectionId,
  onClose,
}: {
  sectionId: number;
  onClose: () => void;
}) {
  const queryClient = useQueryClient();
  const createQuestionMutation = useMutation({
    mutationFn: (data: QuestionFormData) => questionApi.create(sectionId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['section', sectionId] });
      queryClient.invalidateQueries({ queryKey: ['template'] });
      toast.success('Question created successfully');
      onClose();
    },
    onError: (error) =>
      handleQueryError(error, 'Failed to create question. Please try again.'),
  });

  const handleSubmit = (data: QuestionFormData) => {
    createQuestionMutation.mutate(data);
  };

  return { createQuestionMutation, handleSubmit };
}
